<template>
  <div class="clipboard-wrapper">
    <div class="clipboard-footer">
      <div class="clipboard_label">请复制以下内容发送给对方</div>
      <div class="clipboardbtn"
        :class="['clipboardbtn'+id, {'clipboardbtn--success': clipSuccess}]"
        data-clipboard-action="copy"
        :data-clipboard-target="'#clipboardtext' + id"
      >{{copyText}}</div>
    </div>
    <div class="clipboard-content"
      :class="['clipboard-content'+id]"
      :data-clipboard-target="'#clipboardtext' + id"
      data-clipboard-action="copy">
      <textarea ref="clipboardtext"
        class="clipboardtext"
        :id="'clipboardtext' + id"
        :value="clipboardText"
        readonly="readonly"
      />
    </div>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
export default {
  name: 'clicpcard',
  data() {
    return {
      clipSuccess: false,
      clip: null,
      id: parseInt(Math.random() * 10000)
    }
  },
  computed: {
    copyText() {
      return this.clipSuccess ? '复制成功' : '复制信息'
    }
  },
  props: {
    clipboardText: String
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.clip && this.clip.destroy()
  },
  methods: {
    init() {
      const target = `.clipboardbtn${this.id}, .clipboard-content${this.id}`
      this.clip = new ClipboardJS(target)
      this.clip.on('success', (e) => {
        this.clipSuccess = true
        this.delay()
      })
    },
    delay() {
      setTimeout(() => {
        this.clipSuccess = false
      }, 2 * 1000)
    }
  }
}
</script>

<style lang="scss" scoped="">
@import "@/styles/color.scss";
.clipboard-wrapper {
  padding-top: 30px;
  margin-bottom: 30px;
}
.clipboard-content {
}
.clipboardtext {
  width: 250px;
  height: 84px;
  background: none;
  border: 1px solid #D9E2EF;
  border-radius: 2px;
  font-size: 12px;
  color: #5D6F80;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: break-spaces;
  line-height: 16px;
  padding-top: 10px;
  padding-left: 10px;

}
.clipboard-footer {
   line-height: 12px;
   font-size: 12px;
   display: flex;
   justify-content: flex-start;
   align-self: center;
   margin-bottom: 10px;
   padding-left: 10px;
}
.clipboard_label {
  color: #5D6F80;
  font-weight: 400;
}
.clipboardbtn {
  margin-left: 8px;
  color: $blue;
  cursor: pointer;
  text-decoration: underline;
  &--success {
    color: #B5C2D0;
  }
}
</style>
